/**
 * Sprint 32 — parse a free-text invite list (onboarding textarea) into
 * de-duplicated valid / invalid buckets.
 *
 * Splits on newlines, commas, and semicolons so paste-from-anywhere works,
 * trims and lowercases, drops blanks, and dedupes case-insensitively while
 * preserving first-seen order. Validation is intentionally lightweight — the
 * backend is the source of truth; this just stops obvious typos before a
 * round-trip.
 */

// Pragmatic, not RFC-5322-exhaustive: local@domain.tld with a real TLD.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export interface ParsedInviteEmails {
  valid: string[]
  invalid: string[]
}

export function parseInviteEmails(raw: string): ParsedInviteEmails {
  const valid: string[] = []
  const invalid: string[] = []
  const seen = new Set<string>()

  for (const token of raw.split(/[\s,;]+/)) {
    const email = token.trim().toLowerCase()
    if (!email) continue
    if (seen.has(email)) continue
    seen.add(email)
    if (EMAIL_RE.test(email)) valid.push(email)
    else invalid.push(email)
  }

  return { valid, invalid }
}
